import _ from 'lodash';

export const formatCompanyDomain = ({ company }) =>
  _.last(_.split(company.domain, '/'));
